import { $form, $view } from 'signals/global.signals';
import { auth, provider } from 'utils/firebase';
import { signInWithEmailAndPassword, sendPasswordResetEmail, signInWithPopup } from 'firebase/auth';
import { validateEmail } from 'utils/validateEmail';
import displayError from 'utils/displayError';
import displayNotification from 'utils/displayNotification';
import { createUser, getUserByUid } from 'api/users.api';

export const handleClickLogin = async (navigate) => {
  $form.loadingStart();
  const { email, password } = $form.value;
  const emailValidation = validateEmail(email);
  const errs = [...emailValidation];

  try {
    if (emailValidation.length) throw new Error(errs[0]);

    await signInWithEmailAndPassword(auth, email, password);
    navigate('/');
  } catch (error) {
    if (error.code === 'auth/user-not-found') {
      displayError({
        variant: 'warning',
        title: 'Authentication Error',
        message: 'User not found. Please check your email and password, or sign up if you do not have an account.',
      });
    } else if (error.code === 'auth/wrong-password') {
      displayError({
        variant: 'warning',
        title: 'Authentication Error',
        message: 'Incorrect password. Please check your password and try again.',
      });
    } else {
      displayError({
        variant: 'warning',
        title: 'Authentication Error',
        message: error.message,
      });
    }
    $form.loadingEnd();
  }
};

export const handleSubmitResetPassword = async () => {
  $form.loadingStart();
  try {
    await sendPasswordResetEmail(auth, $form.value.email);
    $view.update({ modal: null });
    displayNotification({ title: 'Success!', message: 'Please check your email for next steps' });
  } catch (error) {
    const message = error.code === 'auth/user-not-found'
      ? 'User not found. Please check the email and try again.'
      : error.message;
    displayError({ title: 'Something went wrong:', message });
  } finally {
    $form.loadingEnd();
  }
};

export const handleGoogleLogin = async (navigate) => {
  $form.loadingStart();
  try {
    const { user: fbUser } = await signInWithPopup(auth, provider);

    // Check if user exists in the database
    const existingUser = await getUserByUid(fbUser.uid);
    console.log('Existing User:', existingUser);
    if (existingUser) {
      navigate(`/${existingUser.userTypeId === 1 ? 'founder' : 'investor'}/dashboard`);
      return;
    }

    // If user does not exist, create a new user
    await createUser({
      uid: existingUser.uid,
      email: existingUser.email,
      userTypeId: null,
      onboardingStep: 'todo',
      isVerified: true,
    });
    window.location.reload();
  } catch (error) {
    displayError({
      variant: 'warning',
      title: 'Authentication Error',
      message: error.message,
    });
  } finally {
    $form.loadingEnd();
  }
};
